import { render, staticRenderFns } from "./ItemMedia.vue?vue&type=template&id=28fed326&scoped=true&lang=html&"
import script from "./ItemMedia.vue?vue&type=script&lang=js&"
export * from "./ItemMedia.vue?vue&type=script&lang=js&"
import style0 from "./ItemMedia.vue?vue&type=style&index=0&id=28fed326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fed326",
  null
  
)

export default component.exports